module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "category_box"
  }, [_c('div', {
    staticClass: "category_cont"
  }, [_c('div', {
    staticClass: "category"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "category_lists_box"
  }, [_c('div', {
    staticClass: "category_box"
  }, [_c('div', {
    staticClass: "category_box_cont"
  }, [_c('ul', [(_vm.isLoggedIn) ? _c('li', {
    class: {
      active: _vm.$route.path == '/dashboard/wishlist'
    }
  }, [_c('i', {
    staticClass: "fa fa-list",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "a",
      "to": "/dashboard/wishlist"
    }
  }, [_vm._v("Kívánságlista")])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      active: _vm.$route.path == '/dashboard/favorites'
    }
  }, [_c('i', {
    staticClass: "fa fa-star",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "a",
      "to": "/dashboard/favorites"
    }
  }, [_vm._v("Kedvenceim")])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.$route.path == '/dashboard/basket'
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-basket",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "a",
      "to": "/dashboard/basket"
    }
  }, [_vm._v("Kosár (" + _vm._s(_vm.basketSize == 0 ? 'üres' : _vm.basketSize + ' db') + ")")])], 1), _vm._v(" "), (_vm.isLoggedIn) ? _c('li', {
    class: {
      active: _vm.$route.path == '/dashboard/orders'
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "a",
      "to": "/dashboard/orders"
    }
  }, [_vm._v("Rendeléseim")])], 1) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn) ? _c('li', {
    class: {
      active: _vm.$route.path == '/dashboard/profile'
    }
  }, [_c('i', {
    staticClass: "fa fa-cog",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "a",
      "to": "/dashboard/profile"
    }
  }, [_vm._v("Személyes adatok")])], 1) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn) ? _c('li', {
    class: {
      active: _vm.$route.path == '/dashboard/settings'
    }
  }, [_c('i', {
    staticClass: "fa fa-user",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "a",
      "to": "/dashboard/settings"
    }
  }, [_vm._v("Fiók beállítások")])], 1) : _vm._e()])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "category_title"
  }, [_c('div', {
    staticClass: "section_title"
  }, [_c('div', {
    staticClass: "section_title_cont text-left"
  }, [_c('h3', [_vm._v("PROFIL")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16e2f158","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/main/components/pages/dashboard/Menu.vue
// module id = 107
// module chunks = 0 1 2